import React from 'react';
import './GeneralButton.css';


const GeneralButtonWithImg = (props: any) => {
	const onChangeValueKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13 && props.onClick){ //32 - spacebar, 36 - enter
			props.onClick();
		}
	};

	return (
		<div className="general-btn-background modal-disable-select" style={props.style} 
			tabIndex={0}
			onKeyDown={onChangeValueKeyboard}>
			<button
				onClick={props.onClick}
				className="general-btn general-btn-with-img">
				<img src={props.img.src} style={props.img.style}></img>
				{props.text}
			</button>
		</div>
	);
};
export default GeneralButtonWithImg;